exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message {\n    border-radius: 50px;\n    margin: 0 15px 10px;\n    padding: 15px 20px;\n    position: relative;\n    font-weight: bold;\n}\n.message.to {\n    background-color: #2095FE;\n    color: #fff;\n    margin-left: 100px;\n    text-align: right;\n}\n.message.from {\n    background-color: #E5E4E9;\n    color: #363636;\n    margin-right: 100px;\n}\n.message.to + .message.to,\n.message.from + .message.from {\nmargin-top: -10px;\n}\n@media screen and (max-width: 500px){\n    .message {\n      font-size: 70%;\n      padding: 10px 10px;\n    }\n  \n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/chat/chat-dialog/chat-dialog.component.css
// module id = ../../../../../src/app/chat/chat-dialog/chat-dialog.component.css
// module chunks = main